import { isYouTubeUrl, getYouTubeEmbedUrl } from '@shared/utils/videoUtils';
/**
 * Pure display component for video blocks。
 */
export function VideoView({ url, thumbnail, aspectRatio = '16:9' }) {

    if (!url)
        return null;
    const aspectClass = {
        '16:9': 'aspect-video',
        '4:3': 'aspect-[4/3]',
        '1:1': 'aspect-square',
    }[aspectRatio];
    const isYT = isYouTubeUrl(url);
    return (
      <div className={`relative w-full ${aspectClass} rounded-[8px] overflow-hidden bg-black`}>
        {isYT
        ? (<iframe src={getYouTubeEmbedUrl(url)}
            title="YouTube video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute inset-0 w-full h-full border-0" />)
        : (<video src={url} poster={thumbnail}
          controls autoPlay loop muted playsInline
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
          className="absolute inset-0 w-full h-full object-cover" />)}
    </div>);
}
